import React from "react"
import RelatedPostItem from "./RelatedPostItem"
import PropTypes from "prop-types"

const RelatedPosts = (props) => {
  return (
    <div className="related-posts">
      <h3 className="related-posts-title">You May Also Like:</h3>
      <ul className="related-posts-list">
        {props.posts.slice(0, 4).map((post, i) => (
          <RelatedPostItem key={i} {...props} {...post} />
        ))}
      </ul>
    </div>
  )
}

RelatedPosts.propTypes = {
  trackEvent: PropTypes.func,
  posts: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
}

export default RelatedPosts
